import { toast } from "sonner";

// Robust clipboard copy with a legacy fallback. Only toasts success on success.
export async function copyText(text, successMsg = "Copied to clipboard.") {
  try {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text);
    } else {
      const ta = document.createElement("textarea");
      ta.value = text;
      ta.style.position = "fixed";
      ta.style.left = "-9999px";
      document.body.appendChild(ta);
      ta.focus();
      ta.select();
      const ok = document.execCommand("copy");
      document.body.removeChild(ta);
      if (!ok) throw new Error("copy command failed");
    }
    toast.success(successMsg);
    return true;
  } catch (e) {
    toast.error("Couldn't copy automatically. Please copy the text manually.");
    return false;
  }
}

// Copy rich text (HTML) with a plain-text fallback so pasting into Word/Docs
// keeps formatting, while plain editors still receive readable text.
export async function copyRich(html, plainText, successMsg = "Copied to clipboard.") {
  try {
    if (navigator.clipboard && window.ClipboardItem && window.isSecureContext) {
      const item = new window.ClipboardItem({
        "text/html": new Blob([html], { type: "text/html" }),
        "text/plain": new Blob([plainText], { type: "text/plain" }),
      });
      await navigator.clipboard.write([item]);
      toast.success(successMsg);
      return true;
    }
    // Fallback 1: copy the rendered HTML via a temporary selection (keeps formatting).
    const container = document.createElement("div");
    container.setAttribute("contenteditable", "true");
    container.innerHTML = html;
    container.style.position = "fixed";
    container.style.left = "-9999px";
    document.body.appendChild(container);
    const range = document.createRange();
    range.selectNodeContents(container);
    const sel = window.getSelection();
    sel.removeAllRanges();
    sel.addRange(range);
    const ok = document.execCommand("copy");
    sel.removeAllRanges();
    document.body.removeChild(container);
    if (!ok) throw new Error("copy command failed");
    toast.success(successMsg);
    return true;
  } catch (e) {
    // Fallback 2: plain text only.
    return copyText(plainText, successMsg);
  }
}
